function pricing() {
    const page = document.querySelector('[data-pricing-page]');

    if (!page) {
        return;
    }

    const introItems = Array.from(page.querySelectorAll('[data-pricing-intro]'));
    const revealItems = Array.from(page.querySelectorAll('[data-pricing-reveal]'));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion || !('IntersectionObserver' in window)) {
        introItems.concat(revealItems).forEach((item) => item.classList.add('is-visible'));
        return;
    }

    page.classList.add('is-motion-ready');
    window.requestAnimationFrame(() => {
        introItems.forEach((item, index) => {
            window.setTimeout(() => item.classList.add('is-visible'), index * 90);
        });
    });

    const observer = new IntersectionObserver((entries, currentObserver) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
        });
    }, {rootMargin: '0px 0px -7% 0px', threshold: 0.08});

    revealItems.forEach((item) => observer.observe(item));
}

export {pricing};
